import { makeStyles, mergeClasses, Tooltip, useAnnounce } from '@fluentui/react-components';
import { Report } from '../../../model';
import { NO_COLLATERAL_WARNING_ICON_CLASS } from './reportsGridDialogStyles';

export interface INoCollateralWarningIconProps {
    item: Pick<Report, 'id' | 'executeWarningMessage'>;
}

const useStyles = makeStyles({
    warningIcon: {
        fontSize: '16px',
        marginLeft: '2px',
        border: 'none',
        backgroundColor: 'inherit',
        padding: '0',
    },
});

const NoCollateralWarningIcon = ({ item }: INoCollateralWarningIconProps) => {
    const styles = useStyles();
    const { announce } = useAnnounce();
    const executeWarningMessage = item.executeWarningMessage || '';
    const announceWarning = () => announce(executeWarningMessage, { batchId: `reports-warning-${item.id}` });

    return (
        <Tooltip content={executeWarningMessage} relationship='description' appearance='inverted' withArrow positioning='after'>
            <button
                data-testid={`no-collateral-warning-${item.id}`}
                tabIndex={-1}
                aria-label={executeWarningMessage}
                onPointerEnter={announceWarning}
                aria-disabled
                onFocus={announceWarning}
                className={mergeClasses('e-icons', 'e-warning', NO_COLLATERAL_WARNING_ICON_CLASS, styles.warningIcon)}
            />
        </Tooltip>
    );
};

export default NoCollateralWarningIcon;
